import * as i0 from "@angular/core";
/**
 * Is Single Select Sub List Item Selected Pipe
 *
 * Checks if a sub list item of a single select list item is selected.
 */
export class isSingleSelectSubListItemSelectedPipe {
    transform(item, selectedItem, selectedItemSecurityGroup, activeSecurityGroupTab) {
        if (selectedItem && item.sub_list) {
            // Check if any items in the sub list are selected
            const subItemSelected = item.sub_list.some((subItem) => {
                return subItem.key === selectedItem?.key && selectedItemSecurityGroup === activeSecurityGroupTab;
            });
            // Check if the "select All" option is selected
            const selectAllSelected = item.key === selectedItem.key;
            return subItemSelected || selectAllSelected;
        }
        return false;
    }
}
isSingleSelectSubListItemSelectedPipe.ɵfac = function isSingleSelectSubListItemSelectedPipe_Factory(t) { return new (t || isSingleSelectSubListItemSelectedPipe)(); };
isSingleSelectSubListItemSelectedPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "isSingleSelectSubListItemSelected", type: isSingleSelectSubListItemSelectedPipe, pure: true });
